const EVENT_HANDLERS = {
        openHumMenu: () => {
            const isHumOpen = document.querySelector(".hum--open") || null
            const headerEl = document.querySelector(".mypage--header")
            isHumOpen ? headerEl.classList.remove("hum--open") : headerEl.classList.add("hum--open");
        }
    } //ダイアログ関連
const EVENT_DOMS = {
    humButton: document.getElementById('mypage--hum--button') || null
}
const iniEvent = () => {
    EVENT_DOMS.humButton && EVENT_DOMS.humButton.addEventListener("click", () => EVENT_HANDLERS.openHumMenu())
}
const showDialogs = [...document.querySelectorAll('.show-dialog')]
const closeDialogs = [...document.querySelectorAll('.close-dialog')]
const dialogInners = [...document.querySelectorAll('.dialog')]
const dialogBodies = [...document.querySelectorAll('dialog')]
const dialogHandler = (action, dialogID) => {
    const _dialog = document.getElementById(dialogID) || null
    if (_dialog && action === "show") {
        return _dialog.showModal();
    } else if (_dialog && action === "close") {
        return _dialog.close();
    }
}

dialogBodies.length && dialogBodies.map(dialogBody => dialogBody.addEventListener("click", () => dialogHandler("close", dialogBody.getAttribute('id')), false))
dialogInners.length && dialogInners.map(dialogInner => dialogInner.addEventListener("click", (event) => event.stopPropagation(), false))
showDialogs.length && showDialogs.map(showDialog => showDialog.addEventListener('click', () => dialogHandler("show", showDialog.dataset.dialog)))
closeDialogs.length && closeDialogs.map(closeDialog => closeDialog.addEventListener('click', () => dialogHandler("close", closeDialog.dataset.dialog)))

window.addEventListener("load", () => iniEvent())

$(".gallery").modaal({
	type: 'image',
	overlay_close:true,//モーダル背景クリック時に閉じるか
	before_open:function(){// モーダルが開く前に行う動作
		$('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
	},
	after_close:function(){// モーダルが閉じた後に行う動作
		$('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
	}
});
